import config from '~/common/config/config'

export const SERVER_CONFIG_SYNC_CHANNEL = 'doss_server_config_sync'
const FETCH_TIMEOUT_MS = 10_000

export type ServerConfig = {
  authProvider: string
  maintenanceMode: boolean
  maintenanceStartsAt: string | null
  maintenanceEndsAt: string | null
}

/**
 * Fetches the current server config (auth provider and maintenance mode).
 * Returns null if the request fails (server might be down during maintenance)
 * or if the response is malformed (CDN/LB returning unexpected content).
 */
export const fetchServerConfig = async (): Promise<ServerConfig | null> => {
  try {
    const response = await fetch(`${config.apiUrl}/unauthenticated/auth/config`, {
      method: 'GET',
      credentials: 'include',
      signal: AbortSignal.timeout(FETCH_TIMEOUT_MS),
    })

    if (!response.ok) {
      return null
    }

    const data = await response.json()

    // Validate the response shape - a CDN/LB could return a 200 with unexpected content
    // (cached HTML error page, partial deploy, etc). Only trust known provider values.
    const serverProvider = data.authProvider
    if (serverProvider !== 'workos') {
      return null
    }

    return {
      authProvider: serverProvider,
      maintenanceMode: data.maintenanceMode ?? false,
      maintenanceStartsAt:
        typeof data.maintenanceStartsAt === 'string' ? data.maintenanceStartsAt : null,
      maintenanceEndsAt: typeof data.maintenanceEndsAt === 'string' ? data.maintenanceEndsAt : null,
    }
  } catch {
    // Server might be down during maintenance, request timed out, or other network error
    return null
  }
}
